import {observable,action,runInAction} from 'mobx'
import {json,get} from "../../../utils/ajax";
import {setStore, ValueObjToObj} from "../../../utils/Utils";
import moment from "moment";
import {message} from "antd";

class OrderHistoryStore{
    @observable loading
    @observable searchFields
    @observable list
    @observable detailsList
    @observable formatMessage //国际化

    constructor(){
        this.loading = false
        this.searchFields={
            spareName:'',
            time:''
        }
        this.list=[]
        this.detailsList=[]
        this.formatMessage=()=>{}
    }

    /**
     * 设置store对象，类似react的setState
     * @param obj
     */
    @action
    setStore = (obj) => {
        setStore(obj, this)
    }

    /**
     * 将值从页面绑到store
     * @param changedFields
     */
    @action
    onFieldsChange=(changedFields)=>{
        this.searchFields={...this.searchFields,...ValueObjToObj(changedFields)}
    }

    /**
     * 初始化页面
     * @returns {Promise<void>}
     */
    @action
    initPage=async ()=>{
        this.loading = true
        let search={}
        search[`search.spareName`]= !this.searchFields.spareName ? "" : this.searchFields.spareName;
        search[`search.beginTime`]= !this.searchFields.time.length>0 ? "" : moment(this.searchFields.time[0]).format("YYYY-MM-DD");
        search[`search.endTime`]= !this.searchFields.time.length>0 ? "" : moment(this.searchFields.time[1]).format("YYYY-MM-DD");
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/orderHistory/getList`,search)
        if (res && res.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        runInAction(()=>{
            this.list=Array.isArray(res)?res:[]
            this.loading = false
        })
    }

    /**
     * 重置表单
     */
    @action
    clearSearch=async ()=>{
        this.searchFields={
            spareName:'',
            time:''
        }
        await this.initPage()
    }

    /**
     * 再次提交
     * @param id
     * @returns {Promise<void>}
     */
    @action
    editResubmit=async (id)=>{
       const res= await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/orderHistory/submitAgain/id/${id}`)
        runInAction(()=>{
            if(res.status){
                message.success(this.formatMessage({id: 'orderHistory.SubmitSuccessfully'}))
            }
            this.initPage()
        })
    }

    /**
     * 初始化详情页
     * @returns {Promise<void>}
     */
    @action
    initDetailsPage=async ()=>{
        this.loading = true
        let list = window.location.pathname.split('/')
        let id = list[list.length-1]
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/orderHistory/getOrderInfo/id/${id}`)
        runInAction(()=>{
            this.detailsList=Array.isArray(res)?res:[]
            this.loading = false
        })
    }

    /**
     * 详情页删除
     * @param id
     * @returns {Promise<void>}
     */
    @action
    deleteRowData=async (id)=>{
        const ids = [id]
        await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/orderHistory/orderInfo/batchDel`,ids)
        await this.initDetailsPage()
    }
}
export default new OrderHistoryStore()



// WEBPACK FOOTER //
// ./src/project/dongfeng/OrderHistory/store.js